module.exports = __webpack_public_path__ + "static/img/xbb_rzs.be540c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/xbb_rzs.png
// module id = PF9q
// module chunks = 0